<template>
  <transition name="del-dialog-fade">
    <div class="plv-iar-dialog-mask" v-if="visible">
      <div class="plv-iar-dialog">
        <div class="plv-iar-dialog-body">
          <slot></slot>
        </div>
        <div class="plv-iar-dialog-footer">
          <button class="plv-iar-dialog-action" @click="handleCancel">{{ cancelButtonText }}</button>
          <button class="plv-iar-dialog-action plv-iar-dialog-action--delete" @click="handleConfirm">{{ confirmButtonText }}</button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import langs from '../../../assets/locale/lang/common';
import entryMixin from '../../../assets/mixins/entry';

export default {
  name: 'plv-dialog',
  langs,
  mixins: [entryMixin],
  data() {
    return {
      visible: false,
      cancelButtonText: this.iarTrans('common.cancel'),
      confirmButtonText: this.iarTrans('common.confirm'),
      onCancel: null,
      onConfirm: null,
    };
  },

  methods: {
    $open(options) {
      this.confirmButtonText = options.confirmButtonText || this.iarTrans('common.confirm');
      this.cancelButtonText = options.cancelButtonText || this.iarTrans('common.cancel');
      this.onCancel = options.onCancel || null;
      this.onConfirm = options.onConfirm || null;
      this.visible = true;
    },
    $cancel() {
      this.visible = false;
    },
    handleCancel() {
      this.onCancel && this.onCancel();
      this.$cancel();
    },
    handleConfirm() {
      this.onConfirm && this.onConfirm();
      this.$cancel();
    }
  }
};
</script>

<style lang="scss">
.plv-iar-dialog-mask {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 10002;
  line-height: 1.2;
}

.plv-iar-dialog {
  width: 280px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  overflow: hidden;
  border-radius: 12px;
  background: #fff;

  .plv-iar-dialog-body {
    padding: 26px;
    color: #3D3D3D;
    text-align: center;
  }

  .plv-iar-dialog-footer {
    display: flex;
    align-items: center;
    border-top: 1px solid #e6e6e6;
  }

  .plv-iar-dialog-action {
    width: 100%;
    height: 48px;
    flex-grow: 1;
    box-sizing: border-box;
    text-align: center;
    line-height: 48px;
    color: #3D3D3D;
    font-size: 16px;
    border: none;
    border-right: 1px solid #e6e6e6;
    background: transparent;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;

    &:last-of-type {
      border-right: none;
    }

    &.plv-iar-dialog-action--delete {
      color: #F15D5D;
    }
  }
}

.del-dialog-fade-enter-active, .del-dialog-fade-leave-active {
  transition: opacity .5s;
}

.del-dialog-fade-enter, .del-dialog-fade-leave-to {
  opacity: 0;
}
</style>
